export interface IReturnBookStatus {
    id: number,
    name: string
}

export enum ReturnBookStatus {
    Hold = 1,
    Submitted = 2
}